/**
 * Couleurs graphiques alignées Carbon (séries, pie, bar).
 */

/** Bleu interactif Carbon — série principale */
export const CHART_HEX_INTERACTIVE = '#0f62fe';

/** Vert support / réussite */
export const CHART_HEX_SUPPORT_SUCCESS = '#198038';

export const CHART_HEX_WARNING = '#f1c21b';

export const CHART_HEX_DANGER = '#da1e28';

export const CHART_HEX_PURPLE_60 = '#8a3ffc';

export const CHART_HEX_ORANGE_40 = '#ff832b';

export const CHART_HEX_TEAL_60 = '#007d79';

/** Ordre stable pour pie / bar multi-séries */
export const CHART_QUALITATIVE_HEX = [
  CHART_HEX_INTERACTIVE,
  CHART_HEX_SUPPORT_SUCCESS,
  CHART_HEX_PURPLE_60,
  CHART_HEX_ORANGE_40,
  CHART_HEX_TEAL_60,
  CHART_HEX_DANGER,
] as const;

export function chartSeriesHexByIndex(index: number): string {
  return CHART_QUALITATIVE_HEX[index % CHART_QUALITATIVE_HEX.length];
}
